export function elapsedTime(timer, now = Date.now()) {
  return timer.elapsed + (timer.startedAt === null ? 0 : Math.max(0, now - timer.startedAt));
}

export function updateStopwatch(timer, action, now = Date.now()) {
  if (action === "reset") return { elapsed: 0, startedAt: null };
  if (action === "start") return timer.startedAt === null ? { ...timer, startedAt: now } : timer;
  return { elapsed: elapsedTime(timer, now), startedAt: null };
}

export function formatStopwatch(milliseconds) {
  const seconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds / 60) % 60;
  const pad = (number) => String(number).padStart(2, "0");
  return `${hours ? `${pad(hours)}:` : ""}${pad(minutes)}:${pad(seconds % 60)}`;
}

export function readStopwatch(storage, key) {
  try {
    const timer = JSON.parse(storage.getItem(key));
    if (timer && Number.isFinite(timer.elapsed) && timer.elapsed >= 0 &&
      (timer.startedAt === null || (Number.isFinite(timer.startedAt) && timer.startedAt >= 0))) return timer;
  } catch { /* Storage can be unavailable or contain an older timer format. */ }
  return { elapsed: 0, startedAt: null };
}
